import { render, staticRenderFns } from "./CoreCommissionJsonRule.vue?vue&type=template&id=666c3a40"
import script from "./CoreCommissionJsonRule.vue?vue&type=script&lang=js"
export * from "./CoreCommissionJsonRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports